<template>
  <div>
    <component :is="layout" />
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { mapGetters, mapState } from 'vuex'
import DefaultLayout from './DefaultLayout'
import DefaultLayoutFluid from './DefaultLayoutFluid'
import EmptyLayout from './EmptyLayout'
import DefaultLayoutNoStatus from './DefaultLayoutNoStatus'
import EmptyLayoutContainer from './EmptyLayoutContainer'
import InfoLayout from './InfoLayout'

export default {
  name: 'RootLayout',
  components: {
    DefaultLayout,
    DefaultLayoutFluid,
    EmptyLayout,
    DefaultLayoutNoStatus,
    EmptyLayoutContainer,
    InfoLayout,
  },
  computed: {
    ...mapGetters('myfinbiz', ['organization']),
  },
  setup(props, { root }) {
    if (!root) {
      return
    }

    // organization 값을 가져오기 위해 store에 접근
    const store = root.$store
    const organization = computed(() => store.getters['myfinbiz/organization'])
    
    // created 훅의 로그를 여기로 이동
    console.log('Organization in RootLayout:', organization.value)

    const isEarlyPaymentEnabled = computed(() => {
      const contractCurrent = store.state.contract.current
      return (
        contractCurrent?.status === 'started' &&
        contractCurrent.isEarlyPaymentEnabled === true
      )
    })

    const layout = computed(() => {
      // 빈 레이아웃이 필요한 경우는 따로 있다 (예: signup/pre )
      if( root.$route.meta.layout === 'EmptyLayout') {
        console.log('************* Empty Layout')
        return 'EmptyLayout'
      }

      // if (!isEarlyPaymentEnabled.value) {
      //   return 'InfoLayout'
      // } else {
      //   return root.$route.meta.layout || 'DefaultLayout'
      // }
      return root.$route.meta.layout || 'InfoLayout'
    })
    
    return {
      layout,
    }
  },
  created() {
    // 개발 환경에서만 로그 출력
      console.log('Organization in RootLayout:', this.organization)
  }
}
</script>

<style lang="scss" scoped>
.debug-organization {
  position: fixed;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 10px;
  font-size: 12px;
  max-width: 300px;
  z-index: 9999;
  
  h4 {
    margin: 0 0 5px;
    color: #00ff00;
  }

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
</style>
